import { jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Guid, Nillable } from '@web/utils';
import {
  OrderItemRefundSummaryResponse,
  ProductType,
} from '@web/shared/module/shop';

@jsonObject
export class AdminOrderRefundDataItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly subName?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: ProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(OrderItemRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderItemRefundSummaryResponse>;
}
